import { useEffect, useState } from "react";
import * as Yup from "yup";
import { Col, Row, Form, Spinner } from "react-bootstrap-v5";
import Select from "react-select";
import CourierPartnerService from "../../Services/CourierPartnerService";
import { useHistory } from "react-router-dom";
import csc from "country-state-city";
import helperFunction from "../../Function/helperFunction";
import { useFormik } from "formik";
import { toast } from "react-toastify";


const validationSchema = Yup.object({
  full_name: Yup.string().required("Required"),
  address: Yup.string().required("Required"),
  email: Yup.string().required("Required").email("Please enter valide email"),
  country: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  postal_code: Yup.string().required("Required"),
});

const initialValues = {
  full_name : "",
  address : "",
  email : "",
  country : "",
  state : "",
  city : "",
  postal_code : "",
};


export const EditCourierPartner = () => {
  const [loader, setLoader] = useState(false);
  const [country] = useState(csc.getAllCountries());
  const [countryCode, setCountryCode] = useState("");
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const history = useHistory();
  let param = new URLSearchParams(history.location.search);


    const formik = useFormik({
      initialValues,
      validationSchema: validationSchema,
      onSubmit: (values) => {
        setLoader(true);
        const params = { id: param.get("id"), ...values }
        CourierPartnerService.editCourierPartner(params).then((res) => {
          if (res.status) {
            setLoader(false);
            history.push("/courier-partner-list");
          } else {
            setLoader(false);
            toast.error(res.message);
          }
        }).catch((err)=> {
          toast.error(err.message);
          console.log(err,'err')
        })
      },
    });

    const { values, setFieldValue, errors, touched, getFieldProps, handleSubmit, setValues } = formik;

    const onCountryChange = (e, name) => {
      if (name === "country") {
        setStates(csc.getStatesOfCountry(e.isoCode));
        setCountryCode(e.isoCode);
      } else if (name === "state") {
        setCities(csc.getCitiesOfState(countryCode, e.isoCode));
      }
      setFieldValue([name], e.value);
    };

     useEffect(() => {
      let details = history.location.state;
      getCountryStateCityLists(details)
      setValues({
        full_name: details?.full_name || "",
        email: details?.email || "",
        address: details?.address || "",
        city: details?.city || "",
        state: details?.state || "",
        country: details?.country || "",
        postal_code: details?.postal_code || "",
      });
    }, []);


    const getCountryStateCityLists = (data) => {
      if(data.country && data.state){
        let countryData = country.find((itm)=> itm.name===data.country)
        let allStates = csc.getStatesOfCountry(countryData.isoCode)
        setStates(allStates);
        setCountryCode(countryData.isoCode);
        let statesData = allStates.find((itm)=> itm.name===data.state)
        setCities(csc.getCitiesOfState(countryData.isoCode, statesData.isoCode));
      }
    }

  return (
    <div>
      <div className="row" style={{ width: "50%" }}>
        <div className="card">
          <div className="card-body">
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Row className="p-3">
                {/* full_name  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="full_name"
                    className={
                    "form-control" +
                    (touched.full_name
                      ? !errors.full_name
                        ? " is-valid"
                        : " is-invalid"
                      : "")
                    }
                    {...getFieldProps("full_name")}
                    placeholder="Enter Name"
                  />
                    {touched.full_name && formik.errors.full_name ? (
                    <div className="text-danger">{errors.full_name}</div>
                  ) : null}
                </Col>

                {/* email  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                     className={
                    "form-control" +
                    (touched.email
                      ? !errors.email
                        ? " is-valid"
                        : " is-invalid"
                      : "")
                    }
                    {...getFieldProps("email")}
                    placeholder="Enter Email"
                    autoComplete="new-password"
                  />
                    {touched.email && formik.errors.email ? (
                    <div className="text-danger">{errors.email}</div>
                  ) : null}
                </Col>

                {/* address  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    className={
                    "form-control" +
                    (touched.address
                      ? !errors.address
                        ? " is-valid"
                        : " is-invalid"
                      : "")
                    }
                    {...getFieldProps("address")}
                    placeholder="Enter Address"
                  />
                   {touched.address && errors.address ? (
                    <div className="text-danger">{errors.address}</div>
                  ) : null}
                </Col>


                {/* country  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Country</Form.Label>
                     <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: touched.country
                          ? !errors.country
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    value={helperFunction.convertToSelectList(country,"name","name").find((itm)=> itm.label===formik.values.country)}
                    onChange={(e) => onCountryChange(e, "country")}
                    options={helperFunction.convertToSelectList(
                      country,
                      "name",
                      "name"
                    )}
                  />
                    {touched.country && errors.country ? (
                  <div className="text-danger">{errors.country}</div>
                ) : null}                  
                </Col>


                {/* state  */}
                <Col md={6} className="mb-3">
                  <Form.Label>State</Form.Label>
                    <Select
                      styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: touched.state
                          ? !errors.state
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    value={helperFunction.convertToSelectList(states,"name","name").find((itm)=> itm.label===formik.values.state)}
                    onChange={(e) => onCountryChange(e, "state")}
                    options={helperFunction.convertToSelectList(
                      states,
                      "name",
                      "name"
                    )}
                  />
                   {touched.state && errors.state ? (
                  <div className="text-danger">{errors.state}</div>
                ) : null}      
                </Col>


                  {/* city  */}
                <Col md={6} className="mb-3">
                  <Form.Label>City</Form.Label>
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: touched.city
                            ? !errors.city
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={helperFunction.convertToSelectList(cities,"name","name").find((itm)=> itm.label===formik.values.city)}
                      onChange={(e) => formik.setFieldValue("city", e.value)}
                      options={helperFunction.convertToSelectList(
                        cities,
                        "name",
                        "name"
                      )}
                    />
                  {touched.city && errors.city ? (
                  <div className="text-danger">{errors.city}</div>
                ) : null}         
                </Col>

                 {/* postal code  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Postal Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="postal_code"
                     className={
                    "form-control" +
                    (touched.postal_code
                      ? !errors.postal_code
                        ? " is-valid"
                        : " is-invalid"
                      : "")
                    }
                    {...getFieldProps("postal_code")}
                    placeholder="Enter Postal Code"
                  />
                    {touched.postal_code && errors.postal_code ? (
                    <div className="text-danger">{errors.postal_code}</div>
                  ) : null}
                </Col>
              </Row>






              <Row className="mt-3">
                <Col md={12} className="d-flex justify-content-center">
                  <button
                    className="btn btn-danger w-sm waves-effect waves-light"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light ms-3"
                    type="submit"
                  >
                    {(loader && <Spinner animation="grow" size="sm" />) ||
                      "Submit"}
                  </button>
                </Col>
              </Row>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};


export default EditCourierPartner